module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/trophy-292b3420b2c842a0e549c56774b9f5c6.svg&quot;;"